import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Alert,
  Card,
  CardContent,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchApprovedCourses,
  markCoursePending,
} from "../../../redux/Actions/courseAdminApprovalActions";
import AdminNavbar from "./AdminNavbar";

const CourseAdminApproval = () => {
  const dispatch = useDispatch();
  const [isLoadingAction, setIsLoadingAction] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    dispatch(fetchApprovedCourses());
  }, [dispatch]);

  const { approvedCourses, loading, error } = useSelector(
    (state) => state.courseApprovals || {}
  );

  const handleMarkPending = (teacherCourseId) => {
    setIsLoadingAction(true);
    dispatch(markCoursePending(teacherCourseId))
      .then(() => {
        setSuccessMessage("Course marked as pending successfully!");
        dispatch(fetchApprovedCourses());
        setIsLoadingAction(false);
      })
      .catch(() => {
        setErrorMessage("Error marking course as pending. Please try again.");
        setIsLoadingAction(false);
      });
  };

  useEffect(() => {
    if (successMessage || errorMessage) {
      const timeout = setTimeout(() => {
        setSuccessMessage("");
        setErrorMessage("");
      }, 3000);
      return () => clearTimeout(timeout);
    }
  }, [successMessage, errorMessage]);

  return (
    <div>
      <AdminNavbar />
      <Container>
        <Box sx={{ my: 4 }}>
          <Typography variant="h4" gutterBottom>
            Approved Courses
          </Typography>

          {loading && <Typography>Loading approved courses...</Typography>}
          {error && <Typography color="error">{error}</Typography>}

          {isLoadingAction && <CircularProgress />}
          {successMessage && <Alert severity="success">{successMessage}</Alert>}
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

          {approvedCourses && approvedCourses.length > 0 ? (
            approvedCourses.map((group) => (
              <Card key={group.parentTitle} sx={{ mb: 4, boxShadow: 3 }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: "bold", color: "primary.main" }}
                  >
                    {group.parentTitle}
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Teacher Name
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Course Title
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Course Level
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Start Date
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            End Date
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {group.courses.map((course) => (
                          <TableRow key={`approved-${course.teacherCourseId}`}>
                            <TableCell>
                              {`${course.teacherFirstName} ${course.teacherLastName}`}
                            </TableCell>
                            <TableCell>{course.courseTitle}</TableCell>
                            <TableCell>{course.parentTitle}</TableCell>
                            <TableCell>
                              {new Date(course.startDate).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                              {new Date(course.endDate).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={() =>
                                  handleMarkPending(course.teacherCourseId)
                                }
                                disabled={isLoadingAction}
                              >
                                {isLoadingAction
                                  ? "Processing..."
                                  : "Mark as Pending"}
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography>No approved courses available</Typography>
          )}
        </Box>
      </Container>
    </div>
  );
};

export default CourseAdminApproval;
